import { useIntl } from "react-intl";
import { Modal } from "react-bootstrap";
import { Button, ButtonGroup } from "../../Form";
import { useApi } from "../../../hooks";
import {
  assetShape,
  nodeShape,
  orderShape,
  documentsShape,
} from "../../../shapes";
import { locale } from "../../../utils/browserUtils";
import { DocumentLanguages } from "../../../constants/DocumentLanguages";
import { getDocumentLanguages } from "../../../utils/documentUtils";
import AllOrMultipleSelect from "../../AllOrMultipleSelect";

type Props = {
  stepsState: {
    categoriesSelectionStep?: {
      selectedSwitch?: string;
      selectedItems?: {
        id: string | number;
        name: string;
        code: string;
      }[];
    };
    languagesSelectionStep?: {
      selectedSwitch?: string;
      selectedItems?: {
        id: string | number;
        name: string;
        code: string;
      }[];
    };
  };
  setStepsState: $TSFixMeFunction;
  handleBack?: $TSFixMeFunction;
  handleNext?: $TSFixMeFunction;
  exportType: string;
  includedDocuments?: documentsShape;
  object:
    | {
        asset?: assetShape;
      }
    | {
        node?: nodeShape;
      }
    | {
        order?: orderShape;
      };
};

function LanguagesSelectionStep({
  exportType,
  object,
  handleNext,
  handleBack,
  setStepsState,
  stepsState,
  includedDocuments,
}: Props) {
  const intl = useIntl();
  const browserLanguageWithoutRegion = locale()?.split("-")[0];
  const api = useApi();
  let allLanguages = DocumentLanguages.map(({ code, translationKey }) => {
    const translation = intl.formatMessage({ id: translationKey });
    return { id: code, code, name: translation };
  }).sort((a, b) => a.name.localeCompare(b.name));

  const moveValue = (
    sourceArray: $TSFixMe,
    targetArray: $TSFixMe,
    value: $TSFixMe,
  ) => {
    const index = sourceArray.findIndex((obj: $TSFixMe) => obj.code === value);
    if (index > -1) {
      targetArray.push(sourceArray.splice(index, 1)[0]);
    }
  };

  let topLanguages: $TSFixMe = [];
  moveValue(allLanguages, topLanguages, browserLanguageWithoutRegion);
  if (browserLanguageWithoutRegion !== "en")
    moveValue(allLanguages, topLanguages, "en");

  allLanguages = allLanguages.filter((l) => l.code !== "null");
  const neededLanguagesCodes = getDocumentLanguages(
    includedDocuments,
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    stepsState.categoriesSelectionStep.selectedItems,
  );
  if ((object as $TSFixMe)?.asset) {
    allLanguages = allLanguages.filter((l) =>
      neededLanguagesCodes.includes(l.code),
    );
    // @ts-expect-error TS(7006) FIXME: Parameter 'l' implicitly has an 'any' type.
    topLanguages = topLanguages.filter((l) =>
      neededLanguagesCodes.includes(l.code),
    );
  }

  const { mutate: createExport, isLoading } = api.post.useMutation(
    "/users/current/data_exports",
  );

  const handleConfirmClick = () => {
    const selectedLanguages =
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      stepsState.languagesSelectionStep.selectedItems.map((item) => item.id);
    const languageFilter = selectedLanguages?.length
      ? { language: selectedLanguages.join(",") }
      : {};
    const selectedCategories =
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      stepsState.categoriesSelectionStep.selectedItems.map((item) => item.id);
    const categoryFilter = selectedCategories?.length
      ? { document_category_id: selectedCategories.join(",") }
      : {};
    const getObject = (type: $TSFixMe) => {
      if (type.asset) {
        return { asset: { id: (object as $TSFixMe).asset.id } };
      }
      if (type.node) {
        return { node: { id: (object as $TSFixMe).node.id } };
      }
      return { purchase_order: { id: (object as $TSFixMe).order.id } };
    };

    const objectLink = getObject(object);
    createExport(
      {
        type: exportType,
        ...objectLink,
        ...languageFilter,
        ...categoryFilter,
      },
      { onSuccess: handleNext },
    );
  };

  const handleSelectionSwitch = (value: $TSFixMe) =>
    setStepsState({
      ...stepsState,
      languagesSelectionStep: {
        ...stepsState.languagesSelectionStep,
        selectedSwitch: value,
      },
    });

  const handleSpecificSelectionChange = (newSelectedItems: $TSFixMe) =>
    setStepsState({
      ...stepsState,
      languagesSelectionStep: {
        ...stepsState.languagesSelectionStep,
        selectedItems: newSelectedItems,
      },
    });

  return (
    <>
      <Modal.Body>
        <AllOrMultipleSelect
          title={intl.formatMessage({
            id: "export_files_dialog.file_languages.title",
          })}
          topItemsLabel={intl.formatMessage({
            id: "export_files_dialog.file_languages.top_items_label",
          })}
          moreItemsLabel={intl.formatMessage({
            id: "export_files_dialog.file_languages.more_items_label",
          })}
          itemKey="languages"
          allItems={allLanguages}
          topItems={topLanguages}
          handleSpecificSelectionChange={handleSpecificSelectionChange}
          handleSelectionSwitch={handleSelectionSwitch}
          // @ts-expect-error TS(2322) FIXME: Type '{ selectedSwitch?: string | undefined; selec... Remove this comment to see the full error message
          values={stepsState.languagesSelectionStep}
          includeNoItems={
            neededLanguagesCodes.length === 0 ||
            neededLanguagesCodes.includes("null")
          }
        />
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Button
            text={intl.formatMessage({ id: "button.back" })}
            // @ts-expect-error TS(2322) FIXME: Type '$TSFixMeFunction | undefined' is not assigna... Remove this comment to see the full error message
            onClick={handleBack}
          />
          <Button
            hero
            text={intl.formatMessage({ id: "button.export" })}
            fetching={isLoading}
            onClick={handleConfirmClick}
            disabled={
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              stepsState.languagesSelectionStep.selectedItems.length === 0 &&
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              stepsState.languagesSelectionStep.selectedSwitch ===
                "specific_selection"
            }
          />
        </ButtonGroup>
      </Modal.Footer>
    </>
  );
}

export default LanguagesSelectionStep;
